import { services } from '../../../../api/feathers';

export const GET_BROADCASTS = 'GET_BROADCASTS';
export const SET_BROADCASTS_LOADING = 'SET_BROADCASTS_LOADING';
export const SET_RECIPIENTS_PREVIEW = 'SET_RECIPIENTS_PREVIEW';
export const GET_AUDIENCE_OPTIONS = 'GET_AUDIENCE_OPTIONS';

export const BROADCASTS_PAGE_SIZE = 20;

export function getBroadcasts(page = 0) {
  return (dispatch) => {
    dispatch({ type: SET_BROADCASTS_LOADING, payload: true });

    return services.notificationBroadcasts
      .find({
        query: {
          $limit: BROADCASTS_PAGE_SIZE,
          $skip: page * BROADCASTS_PAGE_SIZE,
          $sort: { createdAt: -1 },
        },
      })
      .then((response) =>
        dispatch({
          type: GET_BROADCASTS,
          payload: { ...response, page },
        })
      )
      .finally(() =>
        dispatch({ type: SET_BROADCASTS_LOADING, payload: false })
      );
  };
}

/**
 * Zera a contagem enquanto o publico esta incompleto, para nao deixar em tela o
 * numero do publico anterior.
 */
export function clearRecipientsPreview() {
  return { type: SET_RECIPIENTS_PREVIEW, payload: null };
}

/**
 * Contagem de destinatarios do publico selecionado. Nao cria nada e nao exige a
 * senha de operacao, entao pode ser consultada a cada mudanca do formulario.
 */
export function getRecipientsPreview(audienceType, audienceIds) {
  return (dispatch) =>
    services.notificationBroadcasts
      .get('preview', {
        query: { audienceType, audienceIds },
      })
      .then((response) =>
        dispatch({
          type: SET_RECIPIENTS_PREVIEW,
          payload: response.recipientsCount,
        })
      )
      .catch(() =>
        dispatch({ type: SET_RECIPIENTS_PREVIEW, payload: null })
      );
}

/**
 * Contas e usuarios oferecidos na selecao de publico.
 */
export function getAudienceOptions() {
  return (dispatch) =>
    Promise.all([
      services.accounts.find({ query: { $limit: 500, $sort: { name: 1 } } }),
      services.users.find({ query: { $limit: 500, $sort: { name: 1 } } }),
    ]).then(([accounts, users]) =>
      dispatch({
        type: GET_AUDIENCE_OPTIONS,
        payload: {
          accounts: accounts.data || [],
          users: users.data || [],
        },
      })
    );
}

/**
 * Dispara o comunicado. A senha de operacao vai junto no payload e e validada
 * no servidor; ela nunca e guardada no estado do dash.
 */
export function sendBroadcast({ title, body, audienceType, audienceIds, password }) {
  return () =>
    services.notificationBroadcasts.create({
      title,
      body,
      audienceType,
      audienceIds,
      password,
    });
}
